// extracted by mini-css-extract-plugin
module.exports = {"container":"law_firm_follow-module__container--3wSc6"};